function minutesLabel(minutes) {
    const hours = Number(minutes || 0) / 60;
    return Number.isInteger(hours) ? String(hours) : String(Number(hours.toFixed(2)));
}

module.exports = {
    minutesLabel
};
